export const backend = process.env.REACT_APP_BACKEND_URL;
export const isNotProduction = process.env.REACT_APP_BACKEND_URL?.includes("localhost") || process.env.REACT_APP_BACKEND_URL?.includes("staging");
export const recurly = process.env.REACT_APP_RECURLY_URL;
export const zendeskDomain = process.env.REACT_APP_ZENDESK_DOMAIN;
export const segmentWriteKey = process.env.REACT_APP_SEGMENT_WRITE_KEY;
export const lens5LoginExpireDate = "2023-01-02T00:00:00.000"; // Mon Jan 02 2023 in user timezone
